export default __webpack_public_path__ + "static/media/Patriots.a429c074.png";